import { LegalDoc } from "@/components/LegalDoc";

const SECTIONS = [
  {
    title: "Cosa sono i cookie",
    blocks: [
      { p: "I cookie sono piccoli file di testo che i siti internet possono memorizzare sul dispositivo dell'utente durante la navigazione." },
      { p: "Alcuni cookie sono necessari per consentire il corretto funzionamento e la sicurezza di un sito." },
      { p: "Altri cookie possono essere utilizzati per finalità statistiche, pubblicitarie o di profilazione." },
      { p: "Il presente sito utilizza esclusivamente cookie tecnici strettamente necessari al funzionamento e alla sicurezza del servizio." },
    ],
  },
  {
    title: "Cookie utilizzati",
    blocks: [
      { p: "A seguito della verifica tecnica effettuata sul sito, risultano utilizzati esclusivamente cookie tecnici connessi ai servizi di sicurezza Cloudflare." },
      {
        cookie: {
          name: "__cf_bm",
          rows: [
            { k: "Fornitore", v: "Cloudflare" },
            { k: "Finalità", v: "protezione del sito da traffico automatizzato e bot, prevenzione degli abusi e sicurezza del servizio." },
            { k: "Tipologia", v: "cookie tecnico strettamente necessario." },
            { k: "Durata", v: "circa 30 minuti di inattività." },
          ],
          note: "Il cookie non viene utilizzato per finalità pubblicitarie o di profilazione.",
        },
      },
      {
        cookie: {
          name: "cf_clearance",
          rows: [
            { k: "Fornitore", v: "Cloudflare" },
            { k: "Finalità", v: "memorizzare l'avvenuto superamento dei controlli di sicurezza Cloudflare e consentire all'utente verificato di continuare la navigazione senza dover ripetere continuamente tali controlli." },
            { k: "Tipologia", v: "cookie tecnico strettamente necessario." },
            { k: "Durata", v: "determinata dalla configurazione del servizio di sicurezza Cloudflare." },
          ],
          note: "Il cookie non viene utilizzato per finalità pubblicitarie o di profilazione.",
        },
      },
    ],
  },
  {
    title: "Cookie analytics e di profilazione",
    blocks: [
      { p: "Il sito non utilizza:" },
      {
        list: [
          "Google Analytics;",
          "PostHog;",
          "Meta Pixel;",
          "LinkedIn Insight Tag;",
          "cookie pubblicitari;",
          "cookie di remarketing;",
          "strumenti di session recording;",
          "strumenti di profilazione.",
        ],
      },
      { p: "Non vengono effettuate attività di tracciamento comportamentale degli utenti." },
      { p: "Per questo motivo il sito non richiede il consenso preventivo tramite cookie banner." },
    ],
  },
  {
    title: "Local Storage e Session Storage",
    blocks: [
      { p: "Il sito non utilizza Local Storage o Session Storage per attività di analytics, profilazione o tracciamento degli utenti." },
    ],
  },
  {
    title: "Social network",
    blocks: [
      { p: "Le icone Facebook e LinkedIn presenti sul sito sono semplici collegamenti esterni." },
      { p: "Il sito non carica automaticamente SDK, widget o tracker di Facebook, LinkedIn o altri social network durante la normale navigazione." },
      { p: "Eventuali dati potranno essere trasmessi ai rispettivi social network soltanto quando l'utente decide autonomamente di cliccare sul relativo collegamento e accedere al servizio esterno." },
      { p: "L'icona Instagram è un semplice collegamento esterno al profilo ufficiale del Professor Carlo Enrico Traverso, che si apre in una nuova scheda: non comporta il caricamento di widget, embed, pixel, SDK Meta o altri strumenti di tracciamento." },
    ],
  },
  {
    title: "Video",
    blocks: [
      { p: "I contenuti video presenti nella sezione Media sono ospitati direttamente dal sito e vengono riprodotti tramite un player nativo." },
      { p: "La visualizzazione dei video non comporta il caricamento automatico di player YouTube, Vimeo o di altri servizi esterni." },
      { p: "I collegamenti verso Primocanale presenti nelle relative card vengono attivati esclusivamente quando l'utente decide di cliccarli." },
    ],
  },
  {
    title: "Google Fonts",
    blocks: [
      { p: "I font utilizzati dal sito sono ospitati localmente." },
      { p: "Durante la navigazione non vengono effettuate richieste ai server Google per il caricamento dei caratteri tipografici." },
    ],
  },
  {
    title: "Gestione dei cookie",
    blocks: [
      { p: "L'utente può configurare il proprio browser per impedire o limitare l'utilizzo dei cookie." },
      { p: "La disabilitazione dei cookie tecnici può tuttavia compromettere alcune funzionalità di sicurezza o impedire il corretto accesso al sito." },
    ],
  },
  {
    title: "Cloudflare",
    blocks: [
      { p: "Per proteggere il sito da traffico illecito, bot e attacchi informatici viene utilizzata l'infrastruttura di sicurezza Cloudflare." },
      { p: "Cloudflare può trattare alcuni dati tecnici necessari alla fornitura dei propri servizi di sicurezza." },
      { p: "Tali strumenti non vengono utilizzati dal sito per finalità pubblicitarie o di profilazione." },
    ],
  },
  {
    title: "Titolare del trattamento",
    blocks: [
      {
        fields: [
          { k: "Titolare", v: "Professor Carlo Enrico Traverso" },
          { k: "Indirizzo", v: "Largo XII Ottobre 62, 16121 Genova (GE)" },
          { k: "Codice Fiscale", v: "TRVCRL54P30I480I" },
          { k: "Partita IVA", v: "02979950991" },
          { k: "Email", v: "mc8620@mclink.it", href: "mailto:mc8620@mclink.it" },
          { k: "PEC", v: "carlo.traverso.ZKE7@sv.omceo.it", href: "mailto:carlo.traverso.ZKE7@sv.omceo.it" },
        ],
      },
    ],
  },
  {
    title: "Modifiche alla Cookie Policy",
    blocks: [
      { p: "La presente Cookie Policy potrà essere modificata in caso di introduzione di nuovi servizi, cookie o strumenti tecnici." },
      { p: "Prima della pubblicazione definitiva del sito dovrà essere effettuato un nuovo controllo tecnico per verificare che la configurazione effettivamente pubblicata corrisponda a quanto descritto nella presente informativa." },
    ],
  },
];

export default function CookiePolicy() {
  return (
    <LegalDoc
      testid="cookie-policy-page"
      title="Cookie Policy"
      updated="16 settembre 2026"
      sections={SECTIONS}
    />
  );
}
